<template>
  <div class="results">
    <result-info label="Tip Amount">{{tipAmount}}</result-info>
    <result-info label="Total" >{{totalPay}}</result-info>
    <the-reset-button />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ResultInfo from './ResultInfo.vue';
import TheResetButton from './TheResetButton.vue';
export default defineComponent({
  name: 'TheCalculatorResultPanel',
  components: { ResultInfo, TheResetButton },
  computed: {
    tipAmount() {
      return this.$store.getters.tipAmount.toFixed(2);
    },
    totalPay() {
      return this.$store.getters.totalPay.toFixed(2);
    },
  },
});
</script>

<style lang="scss" scoped>
.results {
  background-color: $darkest-cyan;
  border-radius: 1rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
}
</style>
